import {translate} from "vue-gettext";

const {gettext: $gettext} = translate;

export default {
    shot_at_asc: 's',
    shot_at_desc: '-s',
    custom: 'c',

    default() {
        return this.shot_at_asc
    },
    options() {
        return [
            {
                id: this.shot_at_asc,
                name: $gettext('Shot At - Asc')
            },
            {
                id: this.shot_at_desc,
                name: $gettext('Shot At - Desc')
            },
            {
                id: this.custom,
                name: $gettext('Custom')
            }
        ]
    }
}